export default __webpack_public_path__ + "static/media/github-gray.022cc22e.svg";